module.exports = __webpack_public_path__ + "public/img/29shuichan.8d0bbc2e.png";